/* global module, require */
const createDocument = require('./createDocument'),
	empty = require('./emptyElement'),
	laptopImg = require('../res/planner-laptop.png');

function PlannerIntro(container) {
	this.name = 'Intro';
	this.container = container;
	this.single = true;
}

PlannerIntro.prototype.activate = function() {
	var content = this.container.content;
	empty(content);

	createDocument(content, [
		{
			className: 'planner-intro',
			_children: [
				{ className: 'header-1', innerText: 'Innovative software' },
				{
					className: 'header-2',
					innerText:
						'3dplanner helps you design and develop creative railing solutions',
				},
				{
					className: 'body',
					innerText:
						'Based on our Balcony Post & Glass / Channel / Wire / Button or Channel Systems, you are able to create a detailed plan of your desired space. From this we can see clearly your requirement and offer a supply only or supply and install price. Our 3D Planner is offered as an aid to creating a bespoke railing system of your choice.',
				},
			],
		},
		{
			className: 'planner-images',
			_children: [
				{ className: 'bar bar-1' },
				{ className: 'bar bar-2' },
				{ className: 'bar bar-3' },
				{ _tag: 'img', className: 'image', src: laptopImg },
			],
		},
		{
			_tag: 'a',
			className: 'action-btn secondary',
			innerText: 'Software Enquiry',
			href: 'https://www.3dvisualplanner.com',
			target: '_blank',
		},
	]);
};

PlannerIntro.prototype.complete = function() {
	return true;
};

module.exports = PlannerIntro;
